import * as React from "react";
import { ui } from "aaa";
import { Link } from "react-router-dom";
import ImageLinkedCamera from "material-ui/SvgIcon";

const IMPRESSUM_URL = "https://www.sparda-hessen.de/impressum.html";
export const GDPR_URL = "https://www.sparda-hessen.de/datenschutz.html";
const NUTZUNGSBEDINGUNGEN_URL = "https://www.sparda-hessen.de/internetauftritt/globale-inhaltsseiten/nutzungsbedingungen.html#text_image";
const EINLAGENSCHUTZ_URL = "https://www.sparda-hessen.de/sicherheit-einlagenschutz/#text";
const AGB_URL = "https://www.sparda-hessen.de/dokumente-formulare-und-downloads/#accordion";
const PREISE_URL = AGB_URL;

const Separator = () => <span style={{ marginLeft: 13, marginRight: 13, color: "white", fontSize: 12 }}>|</span>;
const LinkEntry = (props: { href: string, label: string }) => <span style={{ fontSize: 12, fontFamily: "Arial,sans-serif" }}>
    <a
        style={{ textDecoration: "none", color: "white" }}
        href={props.href}
        target="_blank"
    >
        {props.label}
    </a>
</span>;

const LinkEntryMobile = (props: { href: string, label: string }) => <span style={{ fontSize: 12, fontFamily: "Arial,sans-serif" }}>
    <li>
        {/* tslint:disable-next-line:react-a11y-anchors */}
        <a
            style={{ textDecoration: "none", color: "white", fontSize: 12, fontFamily: "Arial,sans-serif" }}
            href={props.href}
            target="_blank"
        >
            {props.label}
        </a>
    </li>
</span>;

export class GlobalFooter extends React.Component<{}, {}> {

    // tslint:disable-next-line:max-func-body-length
    render() {
        return (
            <footer style={{ height: 130, backgroundColor: "#102648" }}>

                <style>{`
                    @media screen and (max-width: 749px) {
                        .footer {
                            display: none;
                        }
                    }
                    @media screen and (min-width: 750px) {
                        .mobileFooter {
                            display: none;
                        }
                    }
                `}</style>

                <div className={"footer"}>
                    <div style={{ paddingTop: 20, paddingLeft: 20 }}>
                        <LinkEntry href={IMPRESSUM_URL} label={ui.__("bottomBar.legal")} />
                        <Separator />
                        <LinkEntry href={NUTZUNGSBEDINGUNGEN_URL} label={ui.__("bottomBar.termsOfUse")} />
                        <Separator />
                        <LinkEntry href={GDPR_URL} label={ui.__("bottomBar.data")} />
                        <Separator />
                        <LinkEntry href={EINLAGENSCHUTZ_URL} label={ui.__("bottomBar.deposit")} />
                        <Separator />
                        <LinkEntry href={AGB_URL} label={ui.__("bottomBar.conditions")} />
                        <Separator />
                        <LinkEntry href={PREISE_URL} label={ui.__("bottomBar.prices")} />
                    </div>
                </div>

                <div className={"mobileFooter"}>

                    <div style={{ paddingTop: 20, paddingLeft: 20 }}>
                        <ul style={{ width: "49.5%", display: "inline-block", margin: 0, padding: 0, listStyleType: "none", lineHeight: 1.5 }}>
                            <LinkEntryMobile href={IMPRESSUM_URL} label={ui.__("bottomBar.legal")} />
                            <LinkEntryMobile href={NUTZUNGSBEDINGUNGEN_URL} label={ui.__("bottomBar.termsOfUse")} />
                            <LinkEntryMobile href={GDPR_URL} label={ui.__("bottomBar.data")} />
                        </ul>
                        <ul style={{ width: "49.5%", display: "inline-block", margin: 0, padding: 0, listStyleType: "none", lineHeight: 1.5 }}>
                            <LinkEntryMobile href={EINLAGENSCHUTZ_URL} label={ui.__("bottomBar.deposit")} />
                            <LinkEntryMobile href={AGB_URL} label={ui.__("bottomBar.conditions")} />
                            <LinkEntryMobile href={PREISE_URL} label={ui.__("bottomBar.prices")} />
                        </ul>
                    </div>
                </div>

                <div style={{ paddingTop: 20, paddingLeft: 20 }}>
                    <span style={{ color: "white", fontSize: 12, fontFamily: "Arial,sans-serif" }}>{ui.__("bottomBar.sparda")}</span>
                </div>
            </footer>
        );
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/GlobalFooter.tsx